import React, { useEffect } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Heading, Text, Typography } from '@fiverr-private/typography';
import { useIdentificationContext } from '@fiverr-private/identification_core';
import { translate } from '../../../utils/translate';
import { globalBigQueryReporter, globalGrafanaReporter } from '../../../events';
import { BecomeSellerLink } from './BecomeSellerLink';
import { SocialForm } from './SocialForm';

export const InitialStep = () => {
    const { mode, source, setMode } = useIdentificationContext();
    const isSignUp = mode === 'sign_up';

    useEffect(() => {
        globalBigQueryReporter.send('identification.initial.show');
        globalGrafanaReporter.count('identification.%{platform}.initial.show');
    }, []);

    const toggleMode = () => setMode(isSignUp ? 'sign_in' : 'sign_up');

    return (
        <Container
            className="initial-step"
            display="flex"
            direction="column"
            height="100%"
            style={{ marginTop: '-32px' }}
        >
            {isSignUp && (
                <Container flex="none">
                    <BecomeSellerLink source={source} />
                </Container>
            )}
            <Container display="flex" direction="column" gap="10" flex="auto" justifyContent="center">
                <Container>
                    <Heading textAlign="center" size={{ default: 'h_lg' }} fontWeight="bold">
                        {isSignUp ? translate('steps.initial.sign_up.title') : translate('steps.initial.sign_in.title')}
                    </Heading>
                </Container>
                <SocialForm />
                <Container>
                    <Text textAlign="center" size={{ default: 'b_sm', md: 'b_md' }}>
                        <Typography as="span" marginRight="2" color="grey_1100">
                            {translate(
                                isSignUp ? 'steps.initial.sign_up.have_account' : 'steps.initial.sign_in.not_member'
                            )}
                        </Typography>
                        <Typography
                            as="span"
                            decoration="underline"
                            cursor="pointer"
                            fontWeight="semibold"
                            color="grey_1100"
                            onClick={toggleMode}
                        >
                            {translate(
                                isSignUp
                                    ? 'steps.initial.sign_up.button_sign_now'
                                    : 'steps.initial.sign_in.button_join_now'
                            )}
                        </Typography>
                    </Text>
                </Container>
            </Container>
        </Container>
    );
};
